const LoadingBackdrop = () => <div className='absolute w-full h-full bg-white/[.38]' />;

export default LoadingBackdrop;
